/**
 * @author        calvin@zumper.com (Calvin Yau)
 * @copyright     Copyright (c) 2018, Zumper
 * @description   Favorites View Reducer
 */

import { DEFAULT_LISTABLES } from '@zcode/nr/es/shared/bizos/listables'
import { alwaysReducer } from '@zcode/reducers'
import type { FavoritesView } from '@zcode/state-type'
import { combineReducers } from 'redux'
import { type ExtractActions, type Values, handleActions } from 'redux-actions'
import type * as actions from '../actions'
import {
  ADD_LIST_ITEM,
  BEGIN_FETCHING_LISTABLES,
  DONE_FETCHING_LISTABLES,
  HIDE,
  RECEIVE_LISTABLES,
  REMOVE_LIST_ITEM,
  RESET,
} from '../constants/index'

type ActionTypes = ExtractActions<Values<typeof actions>>

const favoritesViewReducer = combineReducers<FavoritesView, ActionTypes>({
  fetchingListables: handleActions(
    {
      [BEGIN_FETCHING_LISTABLES]: alwaysReducer(true),
      [DONE_FETCHING_LISTABLES]: alwaysReducer(false),
      [HIDE]: alwaysReducer(false),
      [RESET]: alwaysReducer(false),
    },
    false
  ),
  listables: handleActions(
    {
      [HIDE]: alwaysReducer(DEFAULT_LISTABLES),
      [RESET]: alwaysReducer(DEFAULT_LISTABLES),
      [RECEIVE_LISTABLES]: (state, action) => {
        const { payload } = action
        if (payload.listables) {
          return payload.listables
        }
        return state
      },
      [REMOVE_LIST_ITEM]: (state, action) => {
        const { payload } = action
        if (payload?.entity) {
          const { listables } = state
          const index = listables.findIndex((e) => e.uId === payload.entity.uId)
          if (index > -1) {
            const newMatchingCount = state.matching - 1
            const newState = {
              ...state,
              listables: [...state.listables],
            }
            newState.listables.splice(index, 1)

            return {
              ...newState,
              matching: newMatchingCount,
            }
          }
        }
        return state
      },
      [ADD_LIST_ITEM]: (state, action) => {
        const { payload } = action
        if (payload?.entity) {
          const { listables } = state
          return {
            ...state,
            listables: [...listables, payload.entity],
          }
        }
        return state
      },
    },
    DEFAULT_LISTABLES
  ),
})

export default favoritesViewReducer
